import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const teamAnalysisSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.TEAM_ANALYSIS_GOALKEEPERS}`,
        popover: {
            title: "Goalkeeper KPI Breakdown",
            description:
                "Average KPI scores for every goalkeeper in the opponent team for the selected tournament. " +
                "Columns include save-based categories such as High-Danger Shots, GSAx, Screened Shots, and more. " +
                "A tier badge indicates each goalkeeper's performance ranking.",
            side: "bottom",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAM_ANALYSIS_PLAYERS}`,
        popover: {
            title: "Field Player KPI Breakdown",
            description:
                "Average KPI scores for every field player in the opponent team. " +
                "Columns cover Defensive, Offensive, Team Play, Effort, and Bonus points alongside the Total KPI. " +
                "Use this table to spot the opponent's strongest players before a match.",
            side: "top",
            align: "start",
        },
    },
];
